<div class="repeating-form-container">
  @if (props.label) {
  <span>{{ props.label }} {{ props['required'] ? '*' : '' }}</span>
  } @if (props.description) {
  <p>{{ props.description }}</p>
  } @for (fieldGroupItem of field.fieldGroup; track fieldGroupItem.id || $index;
  let i = $index) {
  <div class="repeating-form-section">
    <div class="fields-row">
      @for (nestedGroup of fieldGroupItem.fieldGroup; track nestedGroup.id ||
      $index) { @let actualField = getActualField(nestedGroup); @let control =
      getGroupControl(i, nestedGroup); @let labelText =
      getFieldLabel(nestedGroup); @if (actualField) {
      <!-- 1. Custom / File fields render via Formly (prevents matInput error) -->
      @if (isCustomOrFileField(nestedGroup)) {
      <div class="repeating-field-column">
        <formly-field [field]="actualField"></formly-field>
      </div>
      }
      <!-- 2. Standard Material text/number inputs -->
      @else if (control) {
      <mat-form-field>
        @if (labelText) {
        <mat-label>{{ labelText }}</mat-label>
        }
        <input
          matInput
          [type]="actualField.props?.type || 'text'"
          [disabled]="props.disabled ?? false"
          [required]="actualField.props?.required ?? false"
          [formControl]="control"
          [formlyAttributes]="actualField"
        />
        @if (control.hasError('required')) {
        <mat-error>Erforderlich</mat-error>
        }
      </mat-form-field>
      } } }
    </div>

    <button
      class="repeating-form-remove-button"
      matIconButton
      type="button"
      (click)="remove(i)"
      [disabled]="field.fieldGroup?.length === 1"
      [aria-label]="'Remove row ' + (i + 1)"
    >
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
  }
</div>

<div class="repeating-form-add-button">
  <button
    matIconButton
    type="button"
    (click)="add()"
    [disabled]="isMaxReached"
    aria-label="Add new item"
  >
    <mat-icon>add_circle</mat-icon>
  </button>
</div>
